module.exports = __webpack_public_path__ + "img/prize-06.4ba98166.png";